import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useDialogs } from '@work4all/components';

import { useDeleteEntity } from '@work4all/data';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

export const useDeleteAppointments = () => {
  const [deleteEntity] = useDeleteEntity();
  const dialog = useDialogs();
  const { t } = useTranslation();

  const triggerDelete = useCallback(
    (props: {
      appointmentIds: number[];
      recursive?: boolean;
      onCompleted?: (data) => void;
    }) => {
      const { appointmentIds, onCompleted, recursive } = props;
      deleteEntity(
        {
          ids: appointmentIds,
          type: Entities.appointment,
          recursive,
        },
        { onCompleted }
      );
    },
    [deleteEntity]
  );

  const initiateDeleteAppointments = useCallback(
    async (appointmentIds: number[], onCompleted?: (data) => void) => {
      return dialog.confirm({
        title: t('ALERT.APPOINTMENT.DELETE.TITLE'),
        description: t('ALERT.APPOINTMENT.DELETE.DESCRIPTION'),
        cancelLabel: t('COMMON.ABORT'),
        confirmAllLabel: t('ALERTS.APPOINTMENTS.BTN_DELETE_ALL'),
        onConfirmAll: () => {
          triggerDelete({ appointmentIds, recursive: true, onCompleted });
        },
        confirmLabel: t('ALERTS.APPOINTMENTS.BTN_DELETE_SINGLE'),
        onConfirm: () => {
          triggerDelete({ appointmentIds, recursive: false, onCompleted });
        },
      });
    },
    [dialog, t, triggerDelete]
  );

  const deleteAppointmentForAllAttendees = useCallback(
    (appointmentId: number) => {
      triggerDelete({ appointmentIds: [appointmentId], recursive: true });
    },
    [triggerDelete]
  );

  return { initiateDeleteAppointments, deleteAppointmentForAllAttendees };
};
